export * from "./snapp-pro-discount-chip";
export * from "./snapp-pro-discount-chip.types";
